export class Separator { };

export type FieldDef = {
    name: string,
    hasArbeitszeit: boolean,
    label: string
};
export class LieferscheinPositionModel {
    private static model: { [key: string]: Array<FieldDef | Separator> } = {
        'Verstopfungsbehebung': [
            { name: 'sammelleitungschmutzwasser', hasArbeitszeit: true, label: 'Sammelleitung Schmutzwasser' },
            { name: 'kueche', hasArbeitszeit: true, label: 'Küche' },
            { name: 'wc', hasArbeitszeit: true, label: 'WC' },
            { name: 'bad', hasArbeitszeit: true, label: 'Bad' },
            { name: 'regenrohr', hasArbeitszeit: true, label: 'Regenrohr' },
            { name: 'bodenablauf', hasArbeitszeit: true, label: 'Bodenablauf' },
            new Separator(),
            { name: 'anbindung', hasArbeitszeit: false, label: 'Anbindung' },
            { name: 'hauptstrang', hasArbeitszeit: false, label: 'Hauptstrang' },
            { name: 'hauptkanal', hasArbeitszeit: false, label: 'Hauptkanal' },
        ],
        'Kanal TV': [
            { name: 'kanalTvOhneAufnahme', hasArbeitszeit: false, label: 'Kanal TV ohne Aufnahme' },
            { name: 'kanalTvMitAufnahme', hasArbeitszeit: true, label: 'Kanal TV mit Aufnahme' },
            { name: 'kanalortung', hasArbeitszeit: false, label: 'Kanalortung' },
            { name: 'datenexport', hasArbeitszeit: false, label: 'Datenexport' },
            { name: 'druckueberpruefung', hasArbeitszeit: true, label: 'Drucküberprüfung' },
        ],
        'Sonstiges': [
            { name: 'hochdruckspuelung', hasArbeitszeit: true, label: 'Hochdruckspülung' },
            { name: 'fraesarbeiten', hasArbeitszeit: true, label: 'Fräsarbeiten' },
            { name: 'saugarbeiten', hasArbeitszeit: true, label: 'Saugarbeiten' },
            { name: 'hebeanlagenreinigung', hasArbeitszeit: true, label: 'Hebeanlagenreinigung' },
            { name: 'flaechenreinigung', hasArbeitszeit: true, label: 'Flächenreinigung' },
            { name: 'schachtreinigung', hasArbeitszeit: true, label: 'Schachtreinigung' },
            { name: 'lkw', hasArbeitszeit: true, label: 'LKW' },
            { name: 'unimog', hasArbeitszeit: true, label: 'Unimog' },
            { name: 'unimogAufbau', hasArbeitszeit: true, label: 'Unimog mit Aufbau' },
            { name: 'pkw3Seitenkipper', hasArbeitszeit: true, label: 'PKW - 3-seiten Kipper' },
            { name: 'helferarbeiten', hasArbeitszeit: true, label: 'Helferarbeiten' },
            { name: 'helferarbeitenPartie', hasArbeitszeit: true, label: 'Helferarbeiten Partie' },
            { name: 'kanaltechniker', hasArbeitszeit: true, label: 'Kanaltechniker' },
            { name: 'kanaltechnikerPartie', hasArbeitszeit: true, label: 'Kanaltechniker Partie' }
        ],
        'Fahrtenpauschale': [
            { name: 'anabfahrt', hasArbeitszeit: false, label: 'An- und Abfahrt' },
            { name: 'fahrzeugpauschale', hasArbeitszeit: false, label: 'Fahrzeugpauschale' },
            { name: 'anabfahrtWasser', hasArbeitszeit: false, label: 'An- und Abfahrt inkl. Wasserfüllen' },

        ],
        'Kleinmaterial': [
            { name: 'kleinmaterial', hasArbeitszeit: false, label: 'Kleinmaterial' },
        ],
        'Zuschläge': [
            { name: 'samstagszuschlag', hasArbeitszeit: true, label: 'Samstagszuschlag' },
            { name: 'sonntagszuschlag', hasArbeitszeit: true, label: 'Sonn- und Feiertagszuschlag' },
            { name: 'nachtzuschlag', hasArbeitszeit: true, label: 'Nachtzuschlag' },
            { name: 'bereitschaftszuschlag', hasArbeitszeit: false, label: 'Bereitschaftszuschlag' },
            { name: 'zuschlag50', hasArbeitszeit: false, label: 'Zuschlag 50%' },
            { name: 'zuschlag100', hasArbeitszeit: false, label: 'Zuschlag 100%' }


        ],
        'Kanalsanierung': [
            { name: 'punktuelleRohrsanierung', hasArbeitszeit: false, label: 'punktuelle Rohrsanierung' },
            { name: 'inliner', hasArbeitszeit: false, label: 'Inliner' },
            { name: 'schachtsanierung', hasArbeitszeit: false, label: 'Schachtsanierung' }
        ],
        'Abladegebuehr': [
            { name: 'abladegebuehr', hasArbeitszeit: false, label: 'Abladegebühr' },
        ],
        'Kanal TV notwendig': [
            { name: 'kanalTvNotwendig', hasArbeitszeit: false, label: 'Kanal TV notwendig' },
        ],
        'Wird benötigt': [
            { name: 'installateur', hasArbeitszeit: false, label: 'Installateur' },
            { name: 'maler', hasArbeitszeit: false, label: 'Maler / Trockenbauer' },
            { name: 'leckortung', hasArbeitszeit: false, label: 'Leckortung' },
            { name: 'trocknung', hasArbeitszeit: false, label: 'Trocknung' },
            { name: 'angebot', hasArbeitszeit: false, label: 'Angebot' },
            { name: 'kamerabericht', hasArbeitszeit: false, label: 'Kamerabericht' },
        ],
    };

    public static getModel(): { [key: string]: Array<FieldDef | Separator> } {
        return LieferscheinPositionModel.model;
    }
};
